var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerfect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C0F6E3;}\n\t.st1{fill:#3DA27E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8598",
    transform: "translate(-876 -198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_192",
    className: "st0",
    d: "M908,198L908,198c17.7,0,32,14.3,32,32l0,0c0,17.7-14.3,32-32,32l0,0 c-17.7,0-32-14.3-32-32l0,0C876,212.3,890.3,198,908,198z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11944",
    transform: "translate(-11 -313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    className: "st1",
    d: "M935.1,546.4c0.1-1.1-0.4-2.2-1.3-2.9c0.9-0.7,1.3-1.8,1.3-2.9c0.1-1.9-1.4-3.5-3.3-3.6 c-0.1,0-0.2,0-0.3,0h-7.9v-5c0.1-2.7-2-4.9-4.7-5c-0.1,0-0.2,0-0.4,0c-0.4,0-0.7,0.3-0.7,0.7v5.5l-2.7,4l-3.1,2.3v-1.8 c0-0.4-0.3-0.7-0.7-0.7h-8.6c-0.4,0-0.7,0.3-0.7,0.7V558c0,0.4,0.3,0.7,0.7,0.7h8.6c0.4,0,0.7-0.3,0.7-0.7v-0.5 c0.5,0.7,1.3,1.1,2.2,1.2h15.8c1.1,0.1,2.3-0.4,3-1.3c1.1-1.3,1.2-3.2,0.4-4.7c1-0.1,1.7-1,1.6-2c0-1-0.3-1.9-1-2.6 C934.8,547.9,935.2,547.2,935.1,546.4z M910.6,557.2h-7.2v-18.7h7.2V557.2z M930.1,547.2c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h1.4c1.1-0.1,2.1,0.8,2.2,1.9c0,0.1,0,0.1,0,0.2c0,0.5-0.3,0.7-2.2,0.7h-2.9c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7l0,0h2.9c0.7,0,1.1,1,1.1,1.9c0,0.6-0.2,1.2-0.6,1.7c-0.5,0.5-1.2,0.8-1.9,0.8h-15.8 c-0.6,0-1.6-1.3-2.2-2.3v-13.5l4-3c0.1,0,0.1-0.1,0.2-0.2l2.9-4.3c0.1-0.1,0.1-0.3,0.1-0.4v-5c1.7,0.2,3,1.8,2.9,3.5v5.8 c0,0.4,0.3,0.7,0.7,0.7h8.6c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2l0,0h-2.3c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h2.3 c1.1-0.1,2.1,0.8,2.2,1.9c0,0.1,0,0.1,0,0.2c0,0.5-0.3,0.7-2.2,0.7L930.1,547.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    className: "st1",
    d: "M906.9,555.1c0.8,0.1,1.5-0.5,1.5-1.3c0.1-0.8-0.5-1.5-1.3-1.5c-0.8-0.1-1.5,0.5-1.5,1.3 C905.5,554.3,906.1,555,906.9,555.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfect);
export default __webpack_public_path__ + "static/media/perfect.d1a4273258d33522febfe8588c306ebf.svg";
export { ForwardRef as ReactComponent };